module.exports = __webpack_public_path__ + "img/feature_buy_zh.c76f8e70.png";